<template>
  <div v-if="property" class="h-100">
    <ion-card
      @click="goToPreview(property._id as string)"
      class="border-default no-shadow rental-card ion-no-margin h-100 bg-white"
    >
      <div v-if="status" class="tag-status">
        <TagStatus :title="t(`status.${status}`)" :status="status" />
      </div>
      <img
        class="rental-card-img"
        :src="image !== '' ? image : 'https://st-web.lodgerin.com/images/image-not-found.webp'"
        alt=""
      />
      <ion-card-header>
        <ion-card-title
          ><h1 class="font-md bold-medium">{{ name }}</h1></ion-card-title
        >
      </ion-card-header>
      <ion-card-content>
        <div v-if="!hidePrice">
          <SubtitleInformationProperty :property="property" />
        </div>
        <PropertyTypeShow :property="property" :language="language" />
      </ion-card-content>
    </ion-card>
  </div>
</template>

<script setup lang="ts">
  import { IonCardTitle, IonCardHeader, IonCard, IonCardContent } from '@ionic/vue';
  import router from '@/router';
  import TagStatus from './booking/TagStatus.vue';
  import { useI18n } from 'vue-i18n';
  import { Property } from '@/interfaces/elastic/elastic.interface';
  import SubtitleInformationProperty from '@/components/announcement/SubtitleInformationProperty.vue';
  import PropertyTypeShow from '@/components/announcement/PropertyTypeShow.vue';

  withDefaults(
    defineProps<{
      name: string;
      image: string;
      property: Property;
      status?: string;
      hidePrice?: boolean;
      language: string;
    }>(),
    {},
  );

  const goToPreview = (idProperty: string) => {
    router.push({ name: 'AnnouncementPropertyPage', params: { propertyId: idProperty } });
  };
  const { t } = useI18n();
</script>

<style lang="css" scoped>
  .rental-card {
    cursor: pointer;
  }

  .rental-card-img {
    height: 240px;
    width: 100%;
    object-fit: cover;
  }

  ion-card.ion-color .ion-inherit-color,
  ion-card-header.ion-color .ion-inherit-color {
    color: inherit;
    padding-bottom: 0 !important;
  }

  .tag-status {
    position: relative;
    margin-top: -40px;
    top: 40px;
  }
</style>
